import React from "react";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import "./Signin.css";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import {loggedIn} from "../../store/authSlice";
import { useState, useCallback } from "react";
import { useMemo } from "react";
import {useLoginuserMutation} from "../../services/api";
import axios from "axios";
import { toast } from "react-toastify";
import ErrorViewer from "../errorHandler/ErrorViewer";
import { useNavigate } from "react-router-dom";
function Signin() {

  const [loginuser, { isLoading, isError }] = useLoginuserMutation();
  const dispatch = useDispatch();
  const navigator = useNavigate();
  const SignIn =  async ( formData ) => {
    try {
      let response = await axios.post(`http://ec2-3-88-113-28.compute-1.amazonaws.com:8888/auth/token/obtain/`,formData,  {headers: {
        "Content-Type": "application/json",
        // Authorization: `JWT ${localStorage.getItem("token")}`,
      }},);
      console.log('success',response);
      return response;
    } catch (error) {
      console.log(error);
    }
  };
  const onSubmit = (values) => {
    //  SignIn({ email: values.email, password: values.password })
      console.log('values',values);
      const formData= new FormData();
    formData.append("password", values.password);
    formData.append("username", values.email);
    // SignIn(formData);
      loginuser(formData)
      .unwrap()
      .then((payload) => {
        console.log(payload);
        dispatch(loggedIn(payload));
        toast.success("Login Successfully");
        navigator('/listing');
      })
      .catch((error) => {
        console.log(error);
        toast.success("Somthing went wrong");
       
      });
      // dispatch(
      //   loginuser({ email: values.email, password: values.password })
      // ).then((val)=>{dispatch(loggedIn(val?.payload?.data)); toast.success("Login Successfully");})
   
  };

// new code 
const validationSchema = Yup.object().shape({
  email: Yup.string()
    .required("Username is required")
    .email("Please enter a valid email (e.g name@domain.com)."),
  password: Yup.string()
    .required("Password is required")
    .min(4, "Incorrect password"),
});
let defaultValues = { email: "", password: "" };
const methods = useForm({
  mode: "onTouched",
  resolver: yupResolver(validationSchema),
  defaultValues,
});
const {
  register,
  handleSubmit,
  formState: { errors },
} = methods;


  return (
    <>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="signin-card d-flex jusitfy-content-center align-items-center flex-column">
          <p className="signin-heading">Signin</p>
          <div className="d-flex w-100 my-2 flex-column">
            <label className="signin-label">Username</label>
            <input
              className={`signin-input add_search error${Boolean(errors.email)} business_search upper_input px-0`}
              type="email"
              {...register("email")}
             
            ></input>
            {errors.email && <ErrorViewer message={errors.email.message} />}
          </div>
          <div className="d-flex my-2 w-100 flex-column">
            <label className="signin-label">Password</label>
            <input
              className={`signin-input error${Boolean(
                errors.password
              )} add_search business_search upper_input px-0`}
              type="password"
              {...register("password")}
              
              name="password"
            ></input>
            {errors.password && (
              <ErrorViewer message={errors.password.message} />
            )}
          </div>
          <button className="ad_btn mt-2 mx-auto" onClick={handleSubmit(onSubmit)}>
            Sign In
          </button>
        </div>
      </div>
    </>
  );
}

export default Signin;
